import { HeadCell } from "./types";

export const headCells = (t: (key: string) => string): HeadCell[] => {
  return [
    {
      id: "id",
      align: "left",
      disablePadding: false,
      label: t("case-code"),
    },
    {
      id: "user",
      align: "center",
      disablePadding: false,
      label: t("case-owner"),
    },
    {
      id: "lawyer",
      align: "center",
      disablePadding: false,
      label: t("lawyer"),
    },
    {
      id: "createDate",
      align: "center",
      disablePadding: false,
      label: t("create-date"),
    },
    {
      id: null,
      align: "center",
      disablePadding: false,
      label: t("review"),
    },
    {
      id: null,
      align: "right",
      disablePadding: false,
      label: "",
    },
  ];
};
